import axios from 'axios';

console.log('sending requests to server address:', process.env.REACT_APP_SMARTBID_SERVER_BASE_URL)
export const smartbidServer = axios.create({
  baseURL: process.env.REACT_APP_SMARTBID_SERVER_BASE_URL,
});
